import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../lib/supabase';
import Icon from './AppIcon';
import ModalSuperAdmin from '../components/navigation/ModalSuperAdmin';

const ListaCompanies = () => {
  const { t } = useTranslation();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCompany, setSelectedCompany] = useState(null);

  useEffect(() => {
    fetchAziende();
  }, []);

  const fetchAziende = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('aziende')
        .select('*')
        .order('nome_azienda', { ascending: true });

      if (error) throw error;
      setCompanies(data || []);
    } catch (err) {
      console.error("Greška pri dohvaćanju:", err.message);
    } finally {
      setLoading(false);
    }
  };

  const filteredCompanies = companies.filter(c => 
    c.nome_azienda?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="bg-card rounded-xl border border-border shadow-sm overflow-hidden">
      {/* HEADER */}
      <div className="p-6 border-b border-border bg-muted/30 flex justify-between items-center">
        <div>
          <h2 className="text-lg font-bold text-foreground">
            {t('companies.title')}
          </h2>
          <p className="text-xs text-muted-foreground uppercase tracking-wider font-bold">
            {t('companies.total')}: {companies.length}
          </p>
        </div>
        <div className="relative">
          <Icon name="Search" size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            placeholder={t('companies.search_placeholder')}
            className="pl-10 pr-4 py-2 bg-background border border-border rounded-lg text-sm outline-none focus:ring-2 focus:ring-primary/20 w-64"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* TABELA */}
      <div className="overflow-x-auto">
        <table className="w-full text-left">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="p-4 text-[10px] font-black uppercase tracking-[0.2em] text-muted-foreground">
                {t('companies.col_name')}
              </th>
              <th className="p-4 text-[10px] font-black uppercase tracking-[0.2em] text-muted-foreground text-right">
                {t('companies.col_actions')}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {loading ? (
              <tr>
                <td colSpan="2" className="p-12 text-center">
                  <Icon name="Loader2" size={32} className="animate-spin mx-auto text-primary" />
                </td>
              </tr>
            ) : filteredCompanies.length > 0 ? (
              filteredCompanies.map((c) => (
                <tr key={c.uuid || c.id} className="hover:bg-muted/20 transition-all group">
                  <td className="p-4">
                    <span className="font-bold text-foreground group-hover:text-primary transition-colors">
                      {c.nome_azienda}
                    </span>
                  </td>
                  <td className="p-4 text-right">
                    <button 
                      onClick={() => setSelectedCompany(c)}
                      className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary text-primary-foreground rounded-xl hover:opacity-90 transition-all text-[10px] font-black uppercase tracking-widest shadow-sm shadow-primary/20"
                    >
                      <Icon name="Info" size={14} />
                      Info 
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2" className="p-10 text-center text-muted-foreground italic text-sm">
                  {t('companies.no_data')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {selectedCompany && (
        <ModalSuperAdmin 
          company={selectedCompany} 
          onClose={() => setSelectedCompany(null)} 
        />
      )}
    </div>
  );
};

export default ListaCompanies;